<script lang="ts" setup>
import { computed } from 'vue'
import { v4 as uuid } from 'uuid'
import { brand } from '@/config/brands'

defineProps<{
  title: string
  collections: any[]
  allData: any
  ending: boolean
  fetching: boolean
  setInfiniteRef: (el: HTMLElement | null) => void
  handleBookClick: (bookId: string) => void
  noMoreText: string
  loadingText: string
}>()

const isTalewave = computed(() => brand === 'talewave')
</script>

<template>
  <div :ref="setInfiniteRef" class="novelyn-collection-page h-100dvh overflow-scroll" :class="isTalewave ? 'talewave-collection-root' : 'bg-n-bg-global'">
    <!-- 标题放进 BasicNavbar 插槽内,避免被 fixed 导航栏(半透明背景+blur)盖住 -->
    <BasicNavbar class="color-n-text-2">
      <div class="title">
        {{ title }}
      </div>
    </BasicNavbar>

    <!-- 无数据时不渲染空卡片,避免出现细白线 -->
    <div v-if="collections.length" class="novelyn-collection-card px-5">
      <div v-for="(item, index) in collections" :key="index">
        <div
          class="novelyn-collection-row flex items-center space-x-15px cursor-pointer"
          @click="handleBookClick(item.id)"
        >
          <BizBookCover
            :id="uuid()"
            :src="item.contentCoverUrl || ''"
            :extra="{
              module_name: allData.showName,
              module_id: allData.id,
              module_type: allData.columnType,
              author: item.authorInfo.author,
              ...item,
            }"
            class="w-18 rounded"
          />

          <div class="flex-1 overflow-hidden">
            <p class="text-15px font-bold line-clamp-1 text-n-text-1">
              {{ item.contentName }}
            </p>
            <p class="text-13px mt-10px text-n-text-2 line-clamp-2">
              {{ item.introduce }}
            </p>

            <BizShowTags v-if="item.tagList && item.tagList.length" :tags="item.tagList" class="mt-10px" />
          </div>
        </div>
      </div>
    </div>

    <div v-if="ending" class="novelyn-collection-foot py-15px text-13px text-center text-n-text-3" :class="{ 'mt-50px': !collections.length }">
      {{ noMoreText }}
    </div>
    <div v-else-if="fetching" class="novelyn-collection-foot py-15px flex items-center justify-center space-x-4 text-13px text-n-text-3" :class="{ 'mt-50px': !collections.length }">
      <div class="animate-spin">
        <i-icon-park-outline-loading />
      </div>
      <p>{{ loadingText }}</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.novelyn-collection-page {
  padding-bottom: 24px;
  background: var(--novelyn-bg);
}

/* 顶部标题(放进 BasicNavbar 插槽内,与订阅页/排行页一致) */
.title {
  position: absolute;
  inset: 0 58px;
  display: grid;
  place-items: center;
  overflow: hidden;
  pointer-events: none;
  color: var(--novelyn-ink);
  font-family: 'Playfair Display', Georgia, serif;
  font-size: 17px;
  font-weight: 700;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.novelyn-collection-card {
  margin: 54px 16px 0;
  padding: 2px 14px;
  border-radius: 20px;
  background: #fff;
  box-shadow: var(--novelyn-shadow-sm);
}

.novelyn-collection-row {
  min-height: 128px;
  padding: 12px 0;
  border-top: 1px solid var(--novelyn-line);
}

.novelyn-collection-card > div:first-child .novelyn-collection-row {
  border-top: 0;
}
</style>
